import type { VCSHost } from '../../../../shared/projectsV2/vcs';

/**
 * Whether fossabot can open PRs on a project with this VCS host. fossabot works
 * with any GitHub repo, however it was imported. The PRs subnav item and the PRs
 * page both gate on this, so the tab never links to a page that redirects away.
 */
export const isFossabotVcsHost = (vcsHost: VCSHost | null | undefined): boolean => (
  vcsHost === 'github' || vcsHost === 'github-app'
);
